import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concat, EMPTY, of } from 'rxjs';
import { catchError, exhaustMap, map, withLatestFrom } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadBankWithBranches,
  loadBankWithBranchesFailure,
  loadBankWithBranchesSuccess,
  toggleBankWithBranchesLoading,
} from './bank-with-branches.actions';
import {
  selectBankWithBranches,
  selectBankWithBranchesLoading,
} from './bank-with-branches.selectors';

@Injectable()
export class BankWithBranchesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);
  private store = inject(Store);

  constructor() {}

  loadBankWithBranches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBankWithBranches),
      withLatestFrom(
        this.store.select(selectBankWithBranches),
        this.store.select(selectBankWithBranchesLoading),
      ),
      exhaustMap(([_action, list, loading]) => {
        const hasCachedData = Array.isArray(list) && list.length > 0;
        if (hasCachedData) {
          return EMPTY;
        }
        if (loading) {
          return EMPTY;
        }

        return concat(
          of(toggleBankWithBranchesLoading({ loading: true })),
          this.referenceService.referenceLookupGetBanksWithBranchGet().pipe(
            map((response) => {
              const bankWithBranches = response.result || [];
              return loadBankWithBranchesSuccess({ bankWithBranches });
            }),
            catchError((error) => of(loadBankWithBranchesFailure({ error }))),
          ),
        );
      }),
    ),
  );

  loadBankWithBranchesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBankWithBranchesSuccess),
      map(() => toggleBankWithBranchesLoading({ loading: false })),
    ),
  );

  loadBankWithBranchesFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBankWithBranchesFailure),
      map(() => toggleBankWithBranchesLoading({ loading: false })),
    ),
  );
}
